module.exports = __webpack_public_path__ + "static/media/cny-house.5b28a21e.svg";